import React, { useEffect, useState, useContext, useRef } from "react";
import { AppContext } from "../../../store/AppContext";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import _ from "lodash";
import { CustomerGridModel } from "../models";
import {
  emptyMessageTemplate,
  headerGroup,
  lastSyncAtBodyTemplate,
  myobErrorMessageTemplate,
  myobStatusBodyTemplate,
  netoErrorMessageTemplate,
  netoStatusBodyTemplate,
  rowExpansionTemplate,
} from "../GridBodyTemplates";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilter, faSlash, faSync } from "@fortawesome/free-solid-svg-icons";
interface ICustomerGridErrorComponentProps{
    customerData: any,
    loading: boolean,
    /** Authoritative connector failed-customer count from the API `total`, not the
     * loaded page length. Falls back to customerData.length only if not provided. */
    totalRecords?: number,
    error?: string,
    lastRefreshedAt?: Date,
    onRefresh?: () => void,
}

const CustomerGridErrorComponent: React.FC<ICustomerGridErrorComponentProps> = ({ customerData, loading, totalRecords, error, lastRefreshedAt, onRefresh }) => {
  let { State, Dispatch } = useContext(AppContext);
  const dt = useRef<DataTable>(null);

  const [customersData, setcustomersData] = useState<Array<CustomerGridModel>>(customerData ?? []);
  const [expandedRows, setExpandedRows] = useState<any[]>([]);

  useEffect(() => {
    setcustomersData(customerData);
  }, [customerData]);


  const reset = () => {
    dt.current?.reset();
  }

  const header = (
    <div className="d-flex justify-content-between">
        <h5 className="text-left">Failed Customers</h5>
        <div className="col-6 text-right d-flex justify-content-end align-items-center">
            {lastRefreshedAt && (
                <small className="text-muted mr-3">
                    Last refreshed: {lastRefreshedAt.toLocaleTimeString()}
                </small>
            )}
            {onRefresh && (
                <button
                    type="button"
                    className="btn btn-outline-secondary ml-2"
                    onClick={onRefresh}
                    disabled={loading}
                >
                    <FontAwesomeIcon className="mr-2" icon={faSync} />
                    Refresh
                </button>
            )}
            <button
                type="button"
                className="btn btn-outline-secondary ml-2"
                onClick={reset}
            >
                <div className="fa-layers ml-2">
                    <FontAwesomeIcon className="mr-2" icon={faFilter} />
                    <FontAwesomeIcon className="mr-2" icon={faSlash} />
                </div>
                Clear
            </button>
        </div>
    </div>
  );

  return (
    // Fills the remaining viewport height below the page chrome instead of relying on
    // a small default rows count leaving a blank area under the table - mirrors the
    // Synced Customers / Products flex-height treatment.
    <div className="container-fluid customer-grid-flex-container">
      {error && (
        <div className="alert alert-danger" role="alert">
          {error}
        </div>
      )}
      <DataTable
        ref={dt}
        dataKey="Number"
        header={header}
        headerColumnGroup={headerGroup}
        value={customersData}
        className="p-mt-6"
        autoLayout
        emptyMessage={emptyMessageTemplate}
        lazy={loading}
        loading={loading}
        paginator
        rows={10}
        sortField="lastSyncAtForFilter"
        sortOrder={-1}
        selectionMode="multiple"
        expandedRows={expandedRows}
        onRowToggle={(e) => setExpandedRows(e.data)}
        rowExpansionTemplate={(data: any) => rowExpansionTemplate([data])}
        totalRecords={typeof totalRecords === 'number' ? totalRecords : customersData?.length}
        rowsPerPageOptions={[10, 20, 50]}
        scrollable scrollHeight="flex"
        paginatorClassName="p-jc-end"
        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
      >
        <Column expander style={{ width: "3em" }} />
        <Column field="NetoCustomer.Username" />
        <Column field="MyobCustomer.DisplayID" />
        <Column field="NetoCustomer.ActiveText" body={netoStatusBodyTemplate} />
        <Column
          field="MyobCustomer.IsActiveText"
          body={myobStatusBodyTemplate}
        />
        <Column field="CompanyOrUser" />
        <Column
          field="NetoCustomer.syncErrorMessage"
          body={netoErrorMessageTemplate}
        />
        <Column
          field="MyobCustomer.syncErrorMessage"
          body={myobErrorMessageTemplate}
        />
        <Column
          filterField="lastSyncAt"
          field="lastSyncAtForFilter"
          body={lastSyncAtBodyTemplate}
        />
      </DataTable>
    </div>
  );
};

export default CustomerGridErrorComponent;
